import useI18n from '@i18n';
import BaseCollapseWithGradient from '@components/base/BaseCollapseWithGradient';
import { companyName } from '@config/globalDomain';
import { getSeoTextByLocale } from './config';

const SeoContent: React.FC = () => {
    const { t, locale } = useI18n('Offers');

    return (
        <div className="mb-36">
            <BaseCollapseWithGradient>
                <h2 className="mb-5 font-medium text-h2 text-blueGray-800">
                    {t('Affiliate Programs')}
                </h2>
                <p className="text-blueGray-600 text-p1">
                    {t('Using affiliate programs')}
                    <a
                        href={`${process.env.NEXT_PUBLIC_INSTANCE_PREFIX}/${locale}/info/monetization/traffic-monetization/`}
                        target="_blank"
                        rel="noreferrer"
                        className="!underline text-blueGrey-800"
                    >
                        {t("monetize your resource's traffic")}
                    </a>
                    {t('earn money from your readers/viewers/subscribers', { companyName })}
                    {t('affiliate programs are mutually beneficial')}
                </p>
                <h2 className="my-5 font-medium text-h2 text-blueGray-800">
                    {t('Best affiliate programs', { companyName })}
                </h2>
                <p className="mt-5 text-blueGray-600 text-p1">
                    {t('The ePN (eCommerce Partners Network) has 20+ affiliate programs')}
                </p>
                <p className="text-blueGray-600 text-p1">
                    {t('In the process of making money on the Internet, everything is individual')}
                </p>
                <h2 className="my-5 font-medium text-h2 text-blueGray-800">
                    {t('High-paying affiliate programs')}
                </h2>
                {getSeoTextByLocale(locale)}
            </BaseCollapseWithGradient>
        </div>
    );
};

export default SeoContent;
